import { NgModule } from "@angular/core";
import { PHBHPLocalizePackageModule } from "ph-bhp-feature-packages/ph-bhp-localize-package/public_api";
import { PHBHPLayoutPackageModule } from "ph-bhp-feature-packages/ph-bhp-layout-package/public_api";
import { SopObserveComponent } from "./sop/sop.component";
import { PhBhpNewSopobserveComponent } from "./ph-bhp-new-sopobserve/ph-bhp-new-sopobserve.component";
import { PhBhpSelectSopobserveComponent } from "./ph-bhp-select-sopobserve/ph-bhp-select-sopobserve.component";
import { PhBhpStartSopobserveComponent } from "./ph-bhp-start-sopobserve/ph-bhp-start-sopobserve.component";
import { CollapseModule } from "ngx-bootstrap/collapse";
import { PhBhpObserveProtocolComponent } from "./ph-bhp-observe-protocol/ph-bhp-observe-protocol.component";
import { PhBhpFeaturePackageSopobservationModule as sopobservation } from "ph-bhp-feature-packages/ph-bhp-feature-package-sopobservation/public_api";
import { PhBhpUiModule } from "ph-bhp-feature-packages/ph-bhp-ui/src/lib/ph-bhp-ui.module";
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatListModule } from '@angular/material/list';
import { ClientLibComponent, ClientLibModule } from "ph-bhp-feature-packages/ph-bhp-feature-package-check/public_api";
import { PhBhpFeatureComponentsModule } from 'ph-bhp-feature-packages/ph-bhp-feature-components/public_api';
// common libraries

@NgModule({
    declarations: [
        SopObserveComponent,
        PhBhpNewSopobserveComponent,
        PhBhpSelectSopobserveComponent,
        PhBhpStartSopobserveComponent,
        PhBhpObserveProtocolComponent,
    ],
    imports: [
        PHBHPLocalizePackageModule,
        CollapseModule,
        PHBHPLayoutPackageModule,
        sopobservation,
        PhBhpUiModule,
        MatIconModule,
        MatSelectModule,
        MatRadioModule,
        MatListModule,
        ClientLibModule,
        PhBhpFeatureComponentsModule
    ]
})
export class PhBhpFeaturePackageSopobservationModule {}
